import { useLife } from '@/state/life';
import { useMarkets } from '@/state/markets';
import { useWallet } from '@/state/wallet';
import { useNotifications } from '@/state/notifications';
import { useCinematic } from '@/components/CinematicTakeover';
import { useMeta } from '@/state/meta';
import { sounds } from '@/audio/synth';

/**
 * Bartholomew Returns arc.
 *
 * Triggered if you sold the dog AND your sanity is high AND your wife
 * rep is recovering. The dog finds his way home. No decisions, no PR,
 * no tribal swing. Just a moment.
 */

export function startDogReturnsArc(): void {
  useMeta.getState().recordLore('arc-dog-returns', 'Bartholomew Returns');

  useCinematic.getState().fire({
    id: `dog-returns-${Date.now()}`,
    type: 'welcome-back',
    headline: 'BARTHOLOMEW IS AT THE DOOR.',
    subhead: '12 lbs. matted. tired. somehow knew where you lived. somehow forgave you.',
    durationMs: 6500,
  });
  sounds.notifyAlert();

  // Re-add the dog to wallet possessions
  useWallet.setState((s) => {
    const dog = s.possessions.find((p) => p.id === 'dog');
    if (dog) dog.available = true;
  });

  useLife.getState().bumpSanity(12);
  useLife.getState().bumpRelationship('wife', 8);
  useMarkets.getState().addCash(-1_200); // vet visit + groomer

  setTimeout(() => {
    useNotifications.getState().push({
      surfaceId: 'wallet',
      severity: 'info',
      text: 'Bartholomew is home. \$1,200 vet bill. worth it.',
    });
  }, 5_000);
}
